/**
 * Generates a unique name for something (e.g. decks), given a string and a list of existing names
 * If the initial name is not unique in the set, it will add an incremented number to the end until it is.(e.g. 'Deck (2)', 'Deck (3)', etc.).
 * @param name The name you want to ensure is unique
 * @param existingNames The array of existing names that the name should not conflict with.
 * @param disambiguatingNumber The number to append to the name if it is not unique.
 */
export function getUniqueName(
  name: string,
  existingNames: string[] = [],
  disambiguatingNumber?: number
): string {
  const hasDisambiguatingNumber = typeof disambiguatingNumber === "number";
  const attempt = hasDisambiguatingNumber ? `${name} ${disambiguatingNumber}` : name;
  if (existingNames.includes(attempt)) {
    return getUniqueName(
      name,
      existingNames,
      hasDisambiguatingNumber ? disambiguatingNumber + 1 : 2
    );
  }
  return attempt;
}
